import React from 'react';
import { View, Text, StyleSheet, ScrollView, TouchableOpacity, Image } from 'react-native';
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import { createDrawerNavigator, DrawerContentScrollView, useDrawerStatus } from '@react-navigation/drawer';
import { useNavigation, DrawerActions } from '@react-navigation/native';
import { Ionicons } from '@expo/vector-icons';
import { useAuth } from '../contexts/AuthContext';

// Pantallas de autenticación
import LoginScreen from '../screens/auth/LoginScreen';
import RegistroEmpresaScreen from '../screens/auth/RegistroEmpresaScreen';
import EstadoSolicitudScreen from '../screens/auth/EstadoSolicitudScreen';

// Pantallas de super-admin
import SuperAdminDashboardScreen from '../screens/superadmin/SuperAdminDashboardScreen';
import TenantsListScreen from '../screens/superadmin/TenantsListScreen';
import TenantDetalleScreen from '../screens/superadmin/TenantDetalleScreen';
import SolicitudesScreen from '../screens/superadmin/SolicitudesScreen';
import SolicitudDetalleScreen from '../screens/superadmin/SolicitudDetalleScreen';
import PlanesScreen from '../screens/superadmin/PlanesScreen';
import SucursalesScreen from '../screens/sucursales/SucursalesScreen';
import ConsolidadoScreen from '../screens/sucursales/ConsolidadoScreen';
import UsuariosSucursalScreen from '../screens/sucursales/UsuariosSucursalScreen';

// Pantallas principales
import HomeScreen from '../screens/HomeScreen';
import ClientesScreen from '../screens/clientes/ClientesScreen';
import ClienteDetalleScreen from '../screens/clientes/ClienteDetalleScreen';
import NuevoClienteScreen from '../screens/clientes/NuevoClienteScreen';
import VentasScreen from '../screens/ventas/VentasScreen';
import NuevaVentaScreen from '../screens/ventas/NuevaVentaScreen';
import DetalleVentaScreen from '../screens/ventas/DetalleVentaScreen';
import MisVentasHoyScreen from '../screens/ventas/MisVentasHoyScreen';
import DevolucionesScreen from '../screens/devoluciones/Devoluciones';
import NuevaDevolucionScreen from '../screens/devoluciones/NuevaDevolucionScreen';
import DetalleDevolucionScreen from '../screens/devoluciones/DetalleDevolucionScreenNew2';
import InventarioScreen from '../screens/inventario/InventarioScreen';
import ProductoDetalleScreen from '../screens/inventario/ProductoDetalleScreen';
import NuevoProductoScreen from '../screens/inventario/NuevoProductoScreen';
import EditarProductoScreen from '../screens/inventario/EditarProductoScreen';
import LotesScreen from '../screens/inventario/LotesScreen';
import ConteoInventarioScreen from '../screens/inventario/ConteoInventarioScreen';
import DetalleConteoScreen from '../screens/inventario/DetalleConteoScreen';
import BajoStockScreen from '../screens/inventario/BajoStockScreen';
import CategoriasScreen from '../screens/inventario/CategoriasScreen';
import PresentacionesScreen from '../screens/inventario/PresentacionesScreen';
import RutasScreen from '../screens/rutas/RutasScreen';
import NuevaRutaScreen from '../screens/rutas/NuevaRutaScreen';
import DetalleRutaScreen from '../screens/rutas/DetalleRutaScreen';
import EditarRutaScreen from '../screens/rutas/EditarRutaScreen';
import ProveedoresScreen from '../screens/proveedores/ProveedoresScreen';
import NuevoProveedorScreen from '../screens/proveedores/NuevoProveedorScreen';
import ProveedorDetalleScreen from '../screens/proveedores/ProveedorDetalleScreen';
import ReportesScreen from '../screens/reportes/ReportesScreen';
import ReporteGananciasScreen from '../screens/reportes/ReporteGananciasScreen';
import ReporteVentasProductoScreen from '../screens/reportes/ReporteVentasProductoScreen';
import ReporteVentasClienteScreen from '../screens/reportes/ReporteVentasClienteScreen';
import ReporteVentasVendedorScreen from '../screens/reportes/ReporteVentasVendedorScreen';
import ReporteInventarioScreen from '../screens/reportes/ReporteInventarioScreen';
import ReporteVentaDiariaScreen from '../screens/reportes/ReporteVentaDiariaScreen';
import ReporteConsolidadoEntregasScreen from '../screens/reportes/ReporteConsolidadoEntregasScreen';
import ReporteEficienciaScreen from '../screens/reportes/ReporteEficienciaScreen';
import ReporteProductosVendedorScreen from '../screens/reportes/ReporteProductosVendedorScreen';
import ReporteGananciaVendedorScreen from '../screens/reportes/ReporteGananciaVendedorScreen';
import CierreScreen from '../screens/cierres/CierreScreen';
import NuevoCierreScreen from '../screens/cierres/NuevoCierreScreen';
import DetalleCierreScreen from '../screens/cierres/DetalleCierreScreen';
import ConsolidadoDiarioScreen from '../screens/cierres/ConsolidadoDiarioScreen';

// Pantallas de usuarios
import UsuariosScreen from '../screens/usuarios/UsuariosScreen';
import NuevoUsuarioScreen from '../screens/usuarios/NuevoUsuarioScreen';
import EditarUsuarioScreen from '../screens/usuarios/EditarUsuarioScreen';

// Pantallas de bodega
import BodegaScreen from '../screens/bodega/BodegaScreen';
import BodegaChecklistScreen from '../screens/bodega/BodegaChecklistScreen';

// Pantallas de repartidor
import RepartidorScreen from '../screens/repartidor/RepartidorScreen';
import DetalleEntregaScreen from '../screens/repartidor/DetalleEntregaScreen';

// Pantallas de cotizaciones
import CotizacionesScreen from '../screens/cotizaciones/CotizacionesScreen';
import NuevaCotizacionScreen from '../screens/cotizaciones/NuevaCotizacionScreen';
import DetalleCotizacionScreen from '../screens/cotizaciones/DetalleCotizacionScreen';

// Pantallas de comisiones
import ComisionesScreen from '../screens/comisiones/ComisionesScreen';
import ComisionDetalleScreen from '../screens/comisiones/ComisionDetalleScreen';
import ComisionReporteScreen from '../screens/comisiones/ComisionReporteScreen';
import PagoComisionesScreen from '../screens/comisiones/PagoComisionesScreen';
import ConfigComisionesScreen from '../screens/comisiones/ConfigComisionesScreen';

// Pantallas de penalizaciones
import PenalizacionesScreen from '../screens/penalizaciones/PenalizacionesScreen';
import NuevaPenalizacionScreen from '../screens/penalizaciones/NuevaPenalizacionScreen';
import ConfigPenalizacionesScreen from '../screens/penalizaciones/ConfigPenalizacionesScreen';

// Pantallas de vouchers
import VouchersScreen from '../screens/vouchers/VouchersScreen';
import GenerarVoucherScreen from '../screens/vouchers/GenerarVoucherScreen';
import DetalleVoucherScreen from '../screens/vouchers/DetalleVoucherScreen';

// Pantallas de créditos/cuentas por cobrar
import CuentasCobrarScreen from '../screens/creditos/CuentasCobrarScreen';
import DetalleCuentaScreen from '../screens/creditos/DetalleCuentaScreen';

// Pantallas de compras
import ComprasScreen from '../screens/compras/ComprasScreen';
import NuevaCompraScreen from '../screens/compras/NuevaCompraScreen';
import DetalleCompraScreen from '../screens/compras/DetalleCompraScreen';

// Pantallas de ajustes
import AjustesScreen from '../screens/ajustes/AjustesScreen';

const Stack = createNativeStackNavigator();
const Drawer = createDrawerNavigator();

// ============ Hamburger Button ============

const HamburgerButton = () => {
  const navigation = useNavigation();
  return (
    <TouchableOpacity
      onPress={() => navigation.dispatch(DrawerActions.toggleDrawer())}
      style={styles.hamburgerButton}
    >
      <Ionicons name="menu" size={26} color="#007bff" />
    </TouchableOpacity>
  );
};

const mainScreenOptions = (title) => ({
  title,
  headerLeft: () => <HamburgerButton />,
});

// ============ Stack Navigators ============

const ClientesNavigator = () => (
  <Stack.Navigator>
    <Stack.Screen name="ClientesList" component={ClientesScreen} options={mainScreenOptions('Clientes')} />
    <Stack.Screen name="ClienteDetalle" component={ClienteDetalleScreen} options={{ title: 'Detalle del Cliente' }} />
    <Stack.Screen name="NuevoCliente" component={NuevoClienteScreen} options={{ title: 'Nuevo Cliente' }} />
  </Stack.Navigator>
);

const MisVentasNavigator = () => (
  <Stack.Navigator>
    <Stack.Screen name="MisVentasHoyList" component={MisVentasHoyScreen} options={mainScreenOptions('Mis Ventas Hoy')} />
  </Stack.Navigator>
);

const VentasNavigator = () => (
  <Stack.Navigator>
    <Stack.Screen name="VentasList" component={VentasScreen} options={mainScreenOptions('Ventas')} />
    <Stack.Screen name="NuevaVenta" component={NuevaVentaScreen} options={{ title: 'Nueva Venta' }} />
    <Stack.Screen name="DetalleVenta" component={DetalleVentaScreen} options={{ title: 'Detalle de Venta' }} />
    <Stack.Screen name="NuevaDevolucion" component={NuevaDevolucionScreen} options={{ title: 'Nueva Devolución' }} />
  </Stack.Navigator>
);

const InventarioNavigator = () => (
  <Stack.Navigator>
    <Stack.Screen name="InventarioList" component={InventarioScreen} options={mainScreenOptions('Inventario')} />
    <Stack.Screen name="ProductoDetalle" component={ProductoDetalleScreen} options={{ title: 'Detalle del Producto' }} />
    <Stack.Screen name="NuevoProducto" component={NuevoProductoScreen} options={{ title: 'Nuevo Producto' }} />
    <Stack.Screen name="EditarProducto" component={EditarProductoScreen} options={{ title: 'Editar Producto' }} />
    <Stack.Screen name="Lotes" component={LotesScreen} options={{ title: 'Lotes y Vencimientos' }} />
    <Stack.Screen name="ConteoInventario" component={ConteoInventarioScreen} options={{ title: 'Conteos de Inventario' }} />
    <Stack.Screen name="DetalleConteo" component={DetalleConteoScreen} options={{ title: 'Detalle del Conteo' }} />
    <Stack.Screen name="BajoStock" component={BajoStockScreen} options={{ title: 'Productos Bajo Stock' }} />
    <Stack.Screen name="Categorias" component={CategoriasScreen} options={{ title: 'Categorías' }} />
    <Stack.Screen name="Presentaciones" component={PresentacionesScreen} options={{ title: 'Presentaciones' }} />
  </Stack.Navigator>
);

const RutasNavigator = () => (
  <Stack.Navigator>
    <Stack.Screen name="RutasList" component={RutasScreen} options={mainScreenOptions('Rutas')} />
    <Stack.Screen name="NuevaRuta" component={NuevaRutaScreen} options={{ title: 'Nueva Ruta' }} />
    <Stack.Screen name="DetalleRuta" component={DetalleRutaScreen} options={{ title: 'Detalle de Ruta' }} />
    <Stack.Screen name="EditarRuta" component={EditarRutaScreen} options={{ title: 'Editar Ruta' }} />
  </Stack.Navigator>
);

const DevolucionesNavigator = () => (
  <Stack.Navigator>
    <Stack.Screen name="DevolucionesList" component={DevolucionesScreen} options={mainScreenOptions('Devoluciones')} />
    <Stack.Screen name="DetalleDevolucion" component={DetalleDevolucionScreen} options={{ title: 'Detalle de Devolución' }} />
    <Stack.Screen name="NuevaDevolucion" component={NuevaDevolucionScreen} options={{ title: 'Nueva Devolución' }} />
  </Stack.Navigator>
);

const ReportesNavigator = () => (
  <Stack.Navigator>
    <Stack.Screen name="ReportesList" component={ReportesScreen} options={mainScreenOptions('Reportes')} />
    <Stack.Screen name="ReporteGanancias" component={ReporteGananciasScreen} options={{ title: 'Reporte de Ganancias' }} />
    <Stack.Screen name="ReporteVentasProducto" component={ReporteVentasProductoScreen} options={{ title: 'Ventas por Producto' }} />
    <Stack.Screen name="ReporteVentasCliente" component={ReporteVentasClienteScreen} options={{ title: 'Ventas por Cliente' }} />
    <Stack.Screen name="ReporteVentasVendedor" component={ReporteVentasVendedorScreen} options={{ title: 'Ventas por Vendedor' }} />
    <Stack.Screen name="ReporteInventario" component={ReporteInventarioScreen} options={{ title: 'Reporte de Inventario' }} />
    <Stack.Screen name="ReporteCuentasCobrar" component={CuentasCobrarScreen} options={{ title: 'Cuentas por Cobrar' }} />
    <Stack.Screen name="ReporteVentaDiaria" component={ReporteVentaDiariaScreen} options={{ title: 'Venta Diaria' }} />
    <Stack.Screen name="ReporteConsolidadoEntregas" component={ReporteConsolidadoEntregasScreen} options={{ title: 'Consolidado Entregas' }} />
    <Stack.Screen name="ReporteEficiencia" component={ReporteEficienciaScreen} options={{ title: 'Eficiencia Operativa' }} />
    <Stack.Screen name="ReporteProductosVendedor" component={ReporteProductosVendedorScreen} options={{ title: 'Productos por Vendedor' }} />
    <Stack.Screen name="ReporteGananciaVendedor" component={ReporteGananciaVendedorScreen} options={{ title: 'Ganancia por Vendedor' }} />
    <Stack.Screen name="Proveedores" component={ProveedoresScreen} options={{ title: 'Proveedores' }} />
    <Stack.Screen name="NuevoProveedor" component={NuevoProveedorScreen} options={{ title: 'Nuevo Proveedor' }} />
    <Stack.Screen name="ProveedorDetalle" component={ProveedorDetalleScreen} options={{ title: 'Detalle del Proveedor' }} />
    <Stack.Screen name="Cierres" component={CierreScreen} options={{ title: 'Cierres del Día' }} />
    <Stack.Screen name="NuevoCierre" component={NuevoCierreScreen} options={{ title: 'Nuevo Cierre' }} />
    <Stack.Screen name="DetalleCierre" component={DetalleCierreScreen} options={{ title: 'Detalle del Cierre' }} />
    <Stack.Screen name="ConsolidadoDiario" component={ConsolidadoDiarioScreen} options={{ title: 'Consolidado Diario' }} />
  </Stack.Navigator>
);

const BodegaNavigator = () => (
  <Stack.Navigator>
    <Stack.Screen name="BodegaList" component={BodegaScreen} options={mainScreenOptions('Bodega')} />
    <Stack.Screen name="BodegaChecklist" component={BodegaChecklistScreen} options={{ title: 'Verificar Pedido' }} />
  </Stack.Navigator>
);

const CotizacionesNavigator = () => (
  <Stack.Navigator>
    <Stack.Screen name="CotizacionesList" component={CotizacionesScreen} options={mainScreenOptions('Cotizaciones')} />
    <Stack.Screen name="NuevaCotizacion" component={NuevaCotizacionScreen} options={{ title: 'Nueva Cotización' }} />
    <Stack.Screen name="DetalleCotizacion" component={DetalleCotizacionScreen} options={{ title: 'Detalle Cotización' }} />
  </Stack.Navigator>
);

const RepartidorNavigator = () => (
  <Stack.Navigator>
    <Stack.Screen name="RepartidorList" component={RepartidorScreen} options={mainScreenOptions('Entregas')} />
    <Stack.Screen name="DetalleEntrega" component={DetalleEntregaScreen} options={{ title: 'Detalle de Entrega' }} />
  </Stack.Navigator>
);

const UsuariosNavigator = () => (
  <Stack.Navigator>
    <Stack.Screen name="UsuariosList" component={UsuariosScreen} options={mainScreenOptions('Usuarios')} />
    <Stack.Screen name="NuevoUsuario" component={NuevoUsuarioScreen} options={{ title: 'Nuevo Usuario' }} />
    <Stack.Screen name="EditarUsuario" component={EditarUsuarioScreen} options={{ title: 'Editar Usuario' }} />
  </Stack.Navigator>
);

const ComisionesNavigator = () => (
  <Stack.Navigator>
    <Stack.Screen name="ComisionesList" component={ComisionesScreen} options={mainScreenOptions('Comisiones')} />
    <Stack.Screen name="ComisionDetalle" component={ComisionDetalleScreen} options={{ title: 'Detalle de Comisión' }} />
    <Stack.Screen name="ComisionReporte" component={ComisionReporteScreen} options={{ title: 'Reporte de Comisiones' }} />
    <Stack.Screen name="PagoComisiones" component={PagoComisionesScreen} options={{ title: 'Pago de Comisiones' }} />
    <Stack.Screen name="ConfigComisiones" component={ConfigComisionesScreen} options={{ title: 'Configurar Comisiones' }} />
  </Stack.Navigator>
);

const PenalizacionesNavigator = () => (
  <Stack.Navigator>
    <Stack.Screen name="PenalizacionesList" component={PenalizacionesScreen} options={mainScreenOptions('Penalizaciones y Bonos')} />
    <Stack.Screen name="NuevaPenalizacion" component={NuevaPenalizacionScreen} options={{ title: 'Nueva Penalización/Bono' }} />
    <Stack.Screen name="ConfigPenalizaciones" component={ConfigPenalizacionesScreen} options={{ title: 'Configurar Penalizaciones' }} />
  </Stack.Navigator>
);

const CierresNavigator = () => (
  <Stack.Navigator>
    <Stack.Screen name="CierresList" component={CierreScreen} options={mainScreenOptions('Cierres del Día')} />
    <Stack.Screen name="NuevoCierre" component={NuevoCierreScreen} options={{ title: 'Nuevo Cierre' }} />
    <Stack.Screen name="DetalleCierre" component={DetalleCierreScreen} options={{ title: 'Detalle del Cierre' }} />
    <Stack.Screen name="ConsolidadoDiario" component={ConsolidadoDiarioScreen} options={{ title: 'Consolidado Diario' }} />
  </Stack.Navigator>
);

const CreditosNavigator = () => (
  <Stack.Navigator>
    <Stack.Screen name="CuentasCobrarList" component={CuentasCobrarScreen} options={mainScreenOptions('Cuentas por Cobrar')} />
    <Stack.Screen name="DetalleCuenta" component={DetalleCuentaScreen} options={{ title: 'Detalle de Cuenta' }} />
  </Stack.Navigator>
);

const VouchersNavigator = () => (
  <Stack.Navigator>
    <Stack.Screen name="VouchersList" component={VouchersScreen} options={mainScreenOptions('Vouchers')} />
    <Stack.Screen name="GenerarVoucher" component={GenerarVoucherScreen} options={{ title: 'Generar Voucher' }} />
    <Stack.Screen name="DetalleVoucher" component={DetalleVoucherScreen} options={{ title: 'Detalle del Voucher' }} />
  </Stack.Navigator>
);

const ComprasNavigator = () => (
  <Stack.Navigator>
    <Stack.Screen name="ComprasList" component={ComprasScreen} options={mainScreenOptions('Compras')} />
    <Stack.Screen name="NuevaCompra" component={NuevaCompraScreen} options={{ title: 'Nueva Orden de Compra' }} />
    <Stack.Screen name="DetalleCompra" component={DetalleCompraScreen} options={{ title: 'Detalle de Compra' }} />
    <Stack.Screen name="Proveedores" component={ProveedoresScreen} options={{ title: 'Proveedores' }} />
    <Stack.Screen name="NuevoProveedor" component={NuevoProveedorScreen} options={{ title: 'Nuevo Proveedor' }} />
    <Stack.Screen name="ProveedorDetalle" component={ProveedorDetalleScreen} options={{ title: 'Detalle del Proveedor' }} />
  </Stack.Navigator>
);

const ProveedoresNavigator = () => (
  <Stack.Navigator>
    <Stack.Screen name="ProveedoresList" component={ProveedoresScreen} options={mainScreenOptions('Proveedores')} />
    <Stack.Screen name="NuevoProveedor" component={NuevoProveedorScreen} options={{ title: 'Nuevo Proveedor' }} />
    <Stack.Screen name="ProveedorDetalle" component={ProveedorDetalleScreen} options={{ title: 'Detalle del Proveedor' }} />
  </Stack.Navigator>
);

const SuperAdminNavigator = () => (
  <Stack.Navigator>
    <Stack.Screen name="SuperAdminDashboard" component={SuperAdminDashboardScreen} options={mainScreenOptions('Super Admin')} />
    <Stack.Screen name="TenantsList" component={TenantsListScreen} options={{ title: 'Empresas' }} />
    <Stack.Screen name="TenantDetalle" component={TenantDetalleScreen} options={{ title: 'Detalle de Empresa' }} />
    <Stack.Screen name="Solicitudes" component={SolicitudesScreen} options={{ title: 'Solicitudes' }} />
    <Stack.Screen name="SolicitudDetalle" component={SolicitudDetalleScreen} options={{ title: 'Detalle de Solicitud' }} />
    <Stack.Screen name="PlanesList" component={PlanesScreen} options={{ title: 'Planes' }} />
  </Stack.Navigator>
);

// ============ Drawer Item Component ============

const DrawerItem = ({ icon, label, isActive, onPress }) => (
  <TouchableOpacity
    style={[styles.drawerItem, isActive && styles.drawerItemActive]}
    onPress={onPress}
    activeOpacity={0.7}
  >
    <Ionicons
      name={icon}
      size={22}
      color={isActive ? '#007bff' : '#555'}
      style={styles.drawerItemIcon}
    />
    <Text style={[styles.drawerItemLabel, isActive && styles.drawerItemLabelActive]}>
      {label}
    </Text>
  </TouchableOpacity>
);

const DrawerSectionTitle = ({ title }) => (
  <Text style={styles.sectionTitle}>{title}</Text>
);

// ============ Custom Drawer Content ============

const CustomDrawerContent = (props) => {
  const { user, logout, isSuperAdmin, isGrupoAdmin, activeSucursal } = useAuth();
  const { state, navigation } = props;
  const activeRoute = state.routes[state.index]?.name;

  const canAccessReports = user && (user.rol === 'admin' || user.rol === 'supervisor' || user.rol === 'gerente');
  const canAccessBodega = user && (user.rol === 'bodega' || user.rol === 'admin');
  const canAccessRepartidor = user && (user.rol === 'repartidor' || user.rol === 'admin');
  const canManageUsers = user && (user.rol === 'admin' || user.rol === 'supervisor');
  const canAccessComisiones = user && (user.rol === 'admin' || user.rol === 'supervisor' || user.rol === 'gerente' || user.rol === 'vendedor');
  const canAccessCompras = user && (user.rol === 'admin' || user.rol === 'supervisor' || user.rol === 'bodega');

  const navigateTo = (screen) => {
    navigation.navigate(screen);
    navigation.closeDrawer();
  };

  const getRolLabel = (rol) => {
    const roles = {
      admin: 'Administrador',
      supervisor: 'Supervisor',
      vendedor: 'Vendedor',
      bodega: 'Bodeguero',
      repartidor: 'Repartidor',
      gerente: 'Gerente',
    };
    return roles[rol] || rol;
  };

  return (
    <View style={styles.drawerContainer}>
      {/* Header del usuario */}
      <View style={styles.drawerHeader}>
        <View style={styles.avatarContainer}>
          <Ionicons name="person-circle" size={60} color="#fff" />
        </View>
        <Text style={styles.userName}>{user?.nombre || 'Usuario'}</Text>
        <View style={styles.rolBadge}>
          <Text style={styles.rolText}>{getRolLabel(user?.rol)}</Text>
        </View>
        {user?.tenant_nombre && (
          <Text style={styles.tenantNameHeader}>
            {activeSucursal ? activeSucursal.nombre : user.tenant_nombre}
          </Text>
        )}
        {activeSucursal && (
          <Text style={styles.sucursalActivaBadge}>Sucursal activa</Text>
        )}
      </View>

      {/* Menu items */}
      <DrawerContentScrollView {...props} contentContainerStyle={styles.scrollContent}>
        {/* Principal */}
        <DrawerSectionTitle title="PRINCIPAL" />
        <DrawerItem
          icon={activeRoute === 'Home' ? 'home' : 'home-outline'}
          label="Inicio"
          isActive={activeRoute === 'Home'}
          onPress={() => navigateTo('Home')}
        />

        {/* Ventas */}
        <DrawerSectionTitle title="VENTAS" />
        <DrawerItem
          icon={activeRoute === 'Ventas' ? 'cart' : 'cart-outline'}
          label="Ventas"
          isActive={activeRoute === 'Ventas'}
          onPress={() => navigateTo('Ventas')}
        />
        <DrawerItem
          icon={activeRoute === 'MisVentasHoy' ? 'today' : 'today-outline'}
          label="Mis Ventas Hoy"
          isActive={activeRoute === 'MisVentasHoy'}
          onPress={() => navigateTo('MisVentasHoy')}
        />
        <DrawerItem
          icon={activeRoute === 'Cotizaciones' ? 'document-text' : 'document-text-outline'}
          label="Cotizaciones"
          isActive={activeRoute === 'Cotizaciones'}
          onPress={() => navigateTo('Cotizaciones')}
        />
        <DrawerItem
          icon={activeRoute === 'Devoluciones' ? 'return-down-back' : 'return-down-back-outline'}
          label="Devoluciones"
          isActive={activeRoute === 'Devoluciones'}
          onPress={() => navigateTo('Devoluciones')}
        />
        <DrawerItem
          icon={activeRoute === 'Clientes' ? 'people' : 'people-outline'}
          label="Clientes"
          isActive={activeRoute === 'Clientes'}
          onPress={() => navigateTo('Clientes')}
        />

        {/* Inventario y Logística */}
        <DrawerSectionTitle title="INVENTARIO Y LOGÍSTICA" />
        <DrawerItem
          icon={activeRoute === 'Inventario' ? 'cube' : 'cube-outline'}
          label="Inventario"
          isActive={activeRoute === 'Inventario'}
          onPress={() => navigateTo('Inventario')}
        />
        <DrawerItem
          icon={activeRoute === 'Rutas' ? 'map' : 'map-outline'}
          label="Rutas"
          isActive={activeRoute === 'Rutas'}
          onPress={() => navigateTo('Rutas')}
        />
        {canAccessBodega && (
          <DrawerItem
            icon={activeRoute === 'Bodega' ? 'file-tray-stacked' : 'file-tray-stacked-outline'}
            label="Bodega"
            isActive={activeRoute === 'Bodega'}
            onPress={() => navigateTo('Bodega')}
          />
        )}
        {canAccessRepartidor && (
          <DrawerItem
            icon={activeRoute === 'Entregas' ? 'car' : 'car-outline'}
            label="Entregas"
            isActive={activeRoute === 'Entregas'}
            onPress={() => navigateTo('Entregas')}
          />
        )}

        {/* Compras */}
        {canAccessCompras && (
          <>
            <DrawerSectionTitle title="COMPRAS" />
            <DrawerItem
              icon={activeRoute === 'Compras' ? 'bag-handle' : 'bag-handle-outline'}
              label="Compras"
              isActive={activeRoute === 'Compras'}
              onPress={() => navigateTo('Compras')}
            />
            <DrawerItem
              icon={activeRoute === 'ProveedoresNav' ? 'business' : 'business-outline'}
              label="Proveedores"
              isActive={activeRoute === 'ProveedoresNav'}
              onPress={() => navigateTo('ProveedoresNav')}
            />
          </>
        )}

        {/* Administración */}
        {(canAccessReports || canManageUsers || canAccessComisiones) && (
          <>
            <DrawerSectionTitle title="ADMINISTRACIÓN" />
            {canAccessComisiones && (
              <DrawerItem
                icon={activeRoute === 'Comisiones' ? 'cash' : 'cash-outline'}
                label="Comisiones"
                isActive={activeRoute === 'Comisiones'}
                onPress={() => navigateTo('Comisiones')}
              />
            )}
            {canAccessComisiones && (
              <DrawerItem
                icon={activeRoute === 'Penalizaciones' ? 'alert-circle' : 'alert-circle-outline'}
                label="Penalizaciones y Bonos"
                isActive={activeRoute === 'Penalizaciones'}
                onPress={() => navigateTo('Penalizaciones')}
              />
            )}
            {canAccessComisiones && (
              <DrawerItem
                icon={activeRoute === 'Vouchers' ? 'receipt' : 'receipt-outline'}
                label="Vouchers"
                isActive={activeRoute === 'Vouchers'}
                onPress={() => navigateTo('Vouchers')}
              />
            )}
            <DrawerItem
              icon={activeRoute === 'Creditos' ? 'wallet' : 'wallet-outline'}
              label="Cuentas por Cobrar"
              isActive={activeRoute === 'Creditos'}
              onPress={() => navigateTo('Creditos')}
            />
            <DrawerItem
              icon={activeRoute === 'CierresDiarios' ? 'lock-closed' : 'lock-closed-outline'}
              label="Cierres del Día"
              isActive={activeRoute === 'CierresDiarios'}
              onPress={() => navigateTo('CierresDiarios')}
            />
            {canAccessReports && (
              <DrawerItem
                icon={activeRoute === 'Reportes' ? 'bar-chart' : 'bar-chart-outline'}
                label="Reportes"
                isActive={activeRoute === 'Reportes'}
                onPress={() => navigateTo('Reportes')}
              />
            )}
            {canManageUsers && (
              <DrawerItem
                icon={activeRoute === 'Usuarios' ? 'person' : 'person-outline'}
                label="Usuarios"
                isActive={activeRoute === 'Usuarios'}
                onPress={() => navigateTo('Usuarios')}
              />
            )}
          </>
        )}

        {/* Sucursales (admin de grupo) */}
        {isGrupoAdmin && (
          <>
            <DrawerSectionTitle title="SUCURSALES" />
            <DrawerItem
              icon={activeRoute === 'Sucursales' ? 'business' : 'business-outline'}
              label="Sucursales"
              isActive={activeRoute === 'Sucursales'}
              onPress={() => navigateTo('Sucursales')}
            />
            <DrawerItem
              icon={activeRoute === 'Consolidado' ? 'stats-chart' : 'stats-chart-outline'}
              label="Consolidado"
              isActive={activeRoute === 'Consolidado'}
              onPress={() => navigateTo('Consolidado')}
            />
            <DrawerItem
              icon={activeRoute === 'UsuariosSucursal' ? 'people' : 'people-outline'}
              label="Usuarios por sucursal"
              isActive={activeRoute === 'UsuariosSucursal'}
              onPress={() => navigateTo('UsuariosSucursal')}
            />
          </>
        )}

        {/* Super Admin */}
        {isSuperAdmin && (
          <>
            <DrawerSectionTitle title="SUPER ADMIN" />
            <DrawerItem
              icon={activeRoute === 'SuperAdmin' ? 'shield' : 'shield-outline'}
              label="Panel Super Admin"
              isActive={activeRoute === 'SuperAdmin'}
              onPress={() => navigateTo('SuperAdmin')}
            />
          </>
        )}

        {/* Configuración */}
        <DrawerSectionTitle title="CONFIGURACIÓN" />
        <DrawerItem
          icon={activeRoute === 'Ajustes' ? 'settings' : 'settings-outline'}
          label="Ajustes"
          isActive={activeRoute === 'Ajustes'}
          onPress={() => navigateTo('Ajustes')}
        />
      </DrawerContentScrollView>

      {/* Footer con logout */}
      <View style={styles.drawerFooter}>
        <TouchableOpacity style={styles.logoutButton} onPress={logout} activeOpacity={0.7}>
          <Ionicons name="log-out-outline" size={22} color="#e74c3c" />
          <Text style={styles.logoutText}>Cerrar Sesión</Text>
        </TouchableOpacity>
      </View>
    </View>
  );
};

// ============ Drawer Navigator ============

const DrawerNavigator = () => {
  const { user, isSuperAdmin, isGrupoAdmin } = useAuth();

  const canAccessReports = user && (user.rol === 'admin' || user.rol === 'supervisor' || user.rol === 'gerente');
  const canAccessBodega = user && (user.rol === 'bodega' || user.rol === 'admin');
  const canAccessRepartidor = user && (user.rol === 'repartidor' || user.rol === 'admin');
  const canManageUsers = user && (user.rol === 'admin' || user.rol === 'supervisor');
  const canAccessComisiones = user && (user.rol === 'admin' || user.rol === 'supervisor' || user.rol === 'gerente' || user.rol === 'vendedor');
  const canAccessCompras = user && (user.rol === 'admin' || user.rol === 'supervisor' || user.rol === 'bodega');

  return (
    <Drawer.Navigator
      drawerContent={(props) => <CustomDrawerContent {...props} />}
      screenOptions={{
        headerStyle: { backgroundColor: '#007bff' },
        headerTintColor: '#fff',
        headerTitleStyle: { fontWeight: 'bold' },
        drawerType: 'front',
        swipeEnabled: true,
      }}
    >
      <Drawer.Screen name="Home" component={HomeScreen} options={{ title: 'Inicio' }} />
      <Drawer.Screen name="Ventas" component={VentasNavigator} options={{ headerShown: false }} />
      <Drawer.Screen name="MisVentasHoy" component={MisVentasNavigator} options={{ headerShown: false }} />
      <Drawer.Screen name="Cotizaciones" component={CotizacionesNavigator} options={{ headerShown: false }} />
      <Drawer.Screen name="Devoluciones" component={DevolucionesNavigator} options={{ headerShown: false }} />
      <Drawer.Screen name="Clientes" component={ClientesNavigator} options={{ headerShown: false }} />
      <Drawer.Screen name="Inventario" component={InventarioNavigator} options={{ headerShown: false }} />
      <Drawer.Screen name="Rutas" component={RutasNavigator} options={{ headerShown: false }} />
      {canAccessBodega && (
        <Drawer.Screen name="Bodega" component={BodegaNavigator} options={{ headerShown: false }} />
      )}
      {canAccessRepartidor && (
        <Drawer.Screen name="Entregas" component={RepartidorNavigator} options={{ headerShown: false }} />
      )}
      {canAccessCompras && (
        <Drawer.Screen name="Compras" component={ComprasNavigator} options={{ headerShown: false }} />
      )}
      {canAccessCompras && (
        <Drawer.Screen name="ProveedoresNav" component={ProveedoresNavigator} options={{ headerShown: false }} />
      )}
      {canAccessComisiones && (
        <Drawer.Screen name="Comisiones" component={ComisionesNavigator} options={{ headerShown: false }} />
      )}
      {canAccessComisiones && (
        <Drawer.Screen name="Penalizaciones" component={PenalizacionesNavigator} options={{ headerShown: false }} />
      )}
      {canAccessComisiones && (
        <Drawer.Screen name="Vouchers" component={VouchersNavigator} options={{ headerShown: false }} />
      )}
      <Drawer.Screen name="Creditos" component={CreditosNavigator} options={{ headerShown: false }} />
      <Drawer.Screen name="CierresDiarios" component={CierresNavigator} options={{ headerShown: false }} />
      {canAccessReports && (
        <Drawer.Screen name="Reportes" component={ReportesNavigator} options={{ headerShown: false }} />
      )}
      {canManageUsers && (
        <Drawer.Screen name="Usuarios" component={UsuariosNavigator} options={{ headerShown: false }} />
      )}
      <Drawer.Screen name="Ajustes" component={AjustesScreen} options={{ title: 'Ajustes' }} />
      {isGrupoAdmin && (
        <Drawer.Screen name="Sucursales" component={SucursalesScreen} options={{ title: 'Sucursales' }} />
      )}
      {isGrupoAdmin && (
        <Drawer.Screen name="Consolidado" component={ConsolidadoScreen} options={{ title: 'Consolidado' }} />
      )}
      {isGrupoAdmin && (
        <Drawer.Screen name="UsuariosSucursal" component={UsuariosSucursalScreen} options={{ title: 'Usuarios por sucursal' }} />
      )}
      {isSuperAdmin && (
        <Drawer.Screen name="SuperAdmin" component={SuperAdminNavigator} options={{ headerShown: false }} />
      )}
    </Drawer.Navigator>
  );
};

// ============ App Navigator (root) ============

const AppNavigator = () => {
  const { user, initializing } = useAuth();

  if (initializing) {
    return null;
  }

  return (
    <Stack.Navigator screenOptions={{ headerShown: false }}>
      {user ? (
        <Stack.Screen name="Main" component={DrawerNavigator} />
      ) : (
        <>
          <Stack.Screen name="Login" component={LoginScreen} />
          <Stack.Screen name="RegistroEmpresa" component={RegistroEmpresaScreen} options={{ headerShown: true, title: 'Registrar Empresa' }} />
          <Stack.Screen name="EstadoSolicitud" component={EstadoSolicitudScreen} options={{ headerShown: true, title: 'Estado de Solicitud' }} />
        </>
      )}
    </Stack.Navigator>
  );
};

export default AppNavigator;

// ============ Styles ============

const styles = StyleSheet.create({
  drawerContainer: {
    flex: 1,
    backgroundColor: '#fff',
  },
  drawerHeader: {
    backgroundColor: '#007bff',
    paddingTop: 50,
    paddingBottom: 20,
    paddingHorizontal: 20,
    alignItems: 'center',
  },
  avatarContainer: {
    marginBottom: 8,
  },
  userName: {
    color: '#fff',
    fontSize: 18,
    fontWeight: 'bold',
  },
  rolBadge: {
    backgroundColor: 'rgba(255,255,255,0.25)',
    paddingHorizontal: 12,
    paddingVertical: 4,
    borderRadius: 12,
    marginTop: 6,
  },
  rolText: {
    color: '#fff',
    fontSize: 12,
    fontWeight: '600',
  },
  tenantNameHeader: {
    color: 'rgba(255,255,255,0.8)',
    fontSize: 11,
    marginTop: 6,
  },
  sucursalActivaBadge: {
    color: '#fff',
    backgroundColor: 'rgba(255,255,255,0.25)',
    fontSize: 10,
    fontWeight: 'bold',
    marginTop: 4,
    paddingHorizontal: 8,
    paddingVertical: 2,
    borderRadius: 8,
    overflow: 'hidden',
  },
  scrollContent: {
    paddingTop: 8,
    paddingBottom: 20,
  },
  sectionTitle: {
    fontSize: 12,
    fontWeight: '700',
    color: '#999',
    letterSpacing: 1,
    paddingHorizontal: 20,
    paddingTop: 16,
    paddingBottom: 6,
  },
  drawerItem: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingVertical: 12,
    paddingHorizontal: 20,
    marginHorizontal: 8,
    borderRadius: 8,
  },
  drawerItemActive: {
    backgroundColor: '#e8f0fe',
  },
  drawerItemIcon: {
    marginRight: 14,
    width: 24,
    textAlign: 'center',
  },
  drawerItemLabel: {
    fontSize: 15,
    color: '#333',
    fontWeight: '500',
  },
  drawerItemLabelActive: {
    color: '#007bff',
    fontWeight: '700',
  },
  drawerFooter: {
    borderTopWidth: 1,
    borderTopColor: '#eee',
    paddingVertical: 12,
    paddingHorizontal: 20,
  },
  logoutButton: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingVertical: 12,
    paddingHorizontal: 8,
  },
  logoutText: {
    fontSize: 15,
    color: '#e74c3c',
    marginLeft: 14,
    fontWeight: '600',
  },
  hamburgerButton: {
    marginLeft: 8,
    padding: 6,
  },
});
